import { Box, HStack } from "@chakra-ui/react";
import React from "react";

import type { AddressSignedAuthorization } from "types/api/address";

import { Skeleton } from "toolkit/chakra/skeleton";
import AddressEntity from "ui/shared/entities/address/AddressEntity";
import ListItemMobile from "ui/shared/ListItemMobile/ListItemMobile";

import {
  formatAuthorizationStatus,
  formatValidityLabel,
  getChainNameById,
} from "./utils";
interface Props extends AddressSignedAuthorization {
  isLoading?: boolean;
}

const AddressAuthorizationsListItem = ({
  address_hash: addressHash,
  authority,
  chain_id: chainId,
  nonce,
  status,
  validity,
  isLoading,
}: Props) => {
  const statusLabel = formatAuthorizationStatus(status);
  const statusColor = status === "ok" ? "green.500" : "text.error";

  return (
    <ListItemMobile rowGap={3} fontSize="sm">
      <HStack gap={3} w="100%" justifyContent="space-between">
        <Skeleton loading={isLoading} fontWeight={500}>
          Address
        </Skeleton>
        <AddressEntity
          address={{ hash: addressHash }}
          isLoading={isLoading}
          noIcon
        />
      </HStack>
      <HStack gap={3} w="100%" justifyContent="space-between">
        <Skeleton loading={isLoading} fontWeight={500}>
          Authority
        </Skeleton>
        <AddressEntity
          address={{ hash: authority }}
          isLoading={isLoading}
          noIcon
        />
      </HStack>
      <HStack gap={3} w="100%" justifyContent="space-between">
        <Skeleton loading={isLoading} fontWeight={500}>
          Chain
        </Skeleton>
        <Skeleton loading={isLoading} color="text.secondary">
          {getChainNameById(chainId)}
        </Skeleton>
      </HStack>
      <HStack gap={3} w="100%" justifyContent="space-between">
        <Skeleton loading={isLoading} fontWeight={500}>
          Nonce
        </Skeleton>
        <Skeleton loading={isLoading} color="text.secondary">
          {nonce}
        </Skeleton>
      </HStack>
      <HStack gap={3} w="100%" justifyContent="space-between">
        <Skeleton loading={isLoading} fontWeight={500}>
          Status
        </Skeleton>
        <Skeleton loading={isLoading}>
          <Box as="span" color={statusColor}>
            {statusLabel}
          </Box>
        </Skeleton>
      </HStack>
    </ListItemMobile>
  );
};

export default AddressAuthorizationsListItem;
